import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphqlVars } from '../../common/useRetriableGraphqlVars';
import { QUERY_GET_PARENTAL_ASSISTANCE_GUIDELINES_ORGANIZATIONAL } from '../../graphql/queries/parentalAssistanceGuidelines/parentalAssistanceGuidelinesOrganizational';

const nonParentalAssistanceGuidelinesOrganizationalQueryOptions = {
  query: QUERY_GET_PARENTAL_ASSISTANCE_GUIDELINES_ORGANIZATIONAL,
  mapData: (result) => result.parentalAssistanceGuidelinesOrganizational,
  skipQuery: skipIfNull(null)
};

export function useParentalAssistanceGuidelinesOrganizational(filter) {
  return useRetriableGraphqlVars({
    queryOptions: nonParentalAssistanceGuidelinesOrganizationalQueryOptions,
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    },
    variableCreator: [
      () =>
        filter
          ? {
              filter
            }
          : null,
      [filter]
    ]
  });
}
